// extracted by mini-css-extract-plugin
export default {"companyContainer":"mR-z","companyImage":"nR-z","container":"oR-z","heading":"pR-z","darkText":"qR-z","smallHeading":"rR-z","darkBackground":"sR-z","whiteBackground":"tR-z"};